import React, { useEffect } from 'react'
import { Outlet } from 'react-router-dom'
import { useDispatch } from 'react-redux'

import StudentUpcomingClasses from './StudentUpcomingClasses'
import StudentPastClasses from './StudentPastClasses'

const DashboardStudentLayout = () => {
  return (
    <>
      <Outlet />
      <aside>
        <StudentUpcomingClasses />
        <StudentPastClasses />
      </aside>
    </>
  )
}

export default DashboardStudentLayout
